<template>
  <div>
    <h5 v-if="type == 'admin'">
      Permisos del rol {{ selectedRol.rol.toLowerCase() }}
    </h5>
    <h5 v-else>Permisos del usuario</h5>
    <b-row>
      <b-col sm="6">
        <b-form-input
          id="search"
          name="search"
          type="text"
          placeholder="Buscar..."
          v-model="filtersPermissions.search"
          @keypress.enter="search"
        ></b-form-input>
      </b-col>
      <b-col sm="3">
        <b-form-group>
          <el-checkbox
            label="Permisos asignados"
            v-model="filtersPermissions.assigned"
            @change="getAssigned"
            border
          />
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group>
          <b-dropdown
            id="dropdown"
            text="Opciones"
            class="float-right"
            variant="primary"
          >
            <b-dropdown-item @click="assignPage(true)">
              <i class="fa fa-check" />Marcar permisos en pantalla
            </b-dropdown-item>
            <b-dropdown-item @click="assignPage(false)">
              <i class="fa fa-remove" />
              Desmarcar permisos en pantalla
            </b-dropdown-item>
          </b-dropdown>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-input-group-append>
          <b-button variant="primary" @click="search">
            <i class="fa fa-search fa-lg"></i>
            <span class="d-none d-md-inline-block">Buscar</span>
          </b-button>
          <b-button @click="resetFilters">
            <i class="fa fa-eraser fa-lg"></i>
            <span class="d-none d-md-inline-block"> Limpiar</span>
          </b-button>
        </b-input-group-append>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col sm="12">
        <b-table
          responsive
          hover
          bordered
          striped
          thead-class="table-active"
          show-empty
          empty-text="No hay permisos para mostrar"
          :items="permissions.data"
          :fields="columnas"
        >
          <template v-slot:cell(asignacion)="data">
            <b-form-checkbox
              class="text-center assign-permissions"
              size="md"
              @change="assignDesign(data.item.id, $event)"
              v-model="data.item.asignado"
              :disabled="type != 'admin' && data.item.roles.length > 0"
            />
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <el-pagination
          v-model="filtersPermissions.page"
          @size-change="setPerPage"
          @current-change="setPage"
          :current-page="filtersPermissions.page"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="filtersPermissions.perPage"
          :total="permissions.total"
          layout="total, sizes, prev, pager, next"
          class="float-right"
        ></el-pagination>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-button
          @click="setView(1)"
          size="sm"
          variant="secondary"
          class="float-left"
        >
          <i class="fa fa-reply fa-lg" /> Volver
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "permissions",
  props: ["type"],
  data() {
    return {
      columnas: [
        {
          key: "asignacion",
          label: "Asignacion",
          sortable: true,
        },
        {
          key: "codigo",
          label: "Código",
          sortable: true,
        },
        {
          key: "permiso",
          label: "Descripcion",
          sortable: true,
        },
        {
          key: "categoria",
          label: "Categoría",
          sortable: true,
        },
      ],
    };
  },
  created() {},
  methods: {
    async search() {
      if (this.type == "admin") {
        await this.getRolPermissions(this.selectedRol.id);
      } else {
        await this.getUserPermissions(this.selectedUsuario.id);
      }
    },
    async getAssigned() {
      if (this.type == "admin") {
        await this.getRolPermissions(this.selectedRol.id);
      } else {
        await this.getUserPermissions(this.selectedUsuario.id);
      }
    },
    async assignDesign(id, action) {
      if (this.type == "admin") {
        let data = [];
        data.push({
          id: id,
          action: action,
        });
        await this.assignRolPermissions(data);
        await this.getRolPermissions(this.selectedRol.id);
      } else {
        let data = {
          id: this.selectedUsuario.id,
          data: [
            {
              id: id,
              action: action,
            },
          ],
        };
        await this.assignUserPermissions(data);
        await this.getUserPermissions(this.selectedUsuario.id);
      }
    },
    async assignPage(action) {
      let data = [];
      this.permissions.data.forEach((permission) => {
        data.push({
          id: permission.id,
          action: action ? 1 : 0,
        });
      });

      if (this.type == "admin") {
        await this.assignRolPermissions(data);
        await this.getRolPermissions(this.selectedRol.id);
      } else {
        let permissions = {
          id: this.selectedUsuario.id,
          data: data,
        };
        await this.assignUserPermissions(permissions);
        await this.getUserPermissions(this.selectedUsuario.id);
      }
    },
    async resetFilters() {
      this.resetFiltersPermissions();
      if (this.type == "admin") {
        await this.getRolPermissions(this.selectedRol.id);
      } else {
        await this.getUserPermissions(this.selectedUsuario.id);
      }
    },
    async setPerPage(perPage) {
      this.setPerPagePermissions(perPage);
      if (this.type == "admin") {
        await this.getRolPermissions(this.selectedRol.id);
      } else {
        await this.getUserPermissions(this.selectedUsuario.id);
      }
    },
    async setPage(page) {
      this.setPagePermissions(page);
      if (this.type == "admin") {
        await this.getRolPermissions(this.selectedRol.id);
      } else {
        await this.getUserPermissions(this.selectedUsuario.id);
      }
    },
    ...mapMutations("rolesPermissions", [
      "setView",
      "setPerPagePermissions",
      "setPagePermissions",
      "resetFiltersPermissions",
    ]),
    ...mapActions("rolesPermissions", [
      "getRolPermissions",
      "assignRolPermissions",
      "getUserPermissions",
      "assignUserPermissions",
    ]),
  },
  beforeDestroy() {
    this.resetFiltersPermissions();
    this.setView(1);
  },
  computed: {
    ...mapState("rolesPermissions", [
      "permissions",
      "selectedRol",
      "filtersPermissions",
    ]),
    ...mapState("empresa", ["rolesSeleccionados", "selectedUsuario"]),
  },
};
</script>
<style>
.assign-permissions label {
  cursor: pointer;
}
</style>
